<!-- Google Code for Landing Page Aparelhos Conversion Page -->
<script type="text/javascript">
/* <![CDATA[ */
var google_conversion_id = 1036218422;
var google_conversion_label = "7jGxCI2m9IUBELbgje4D";
var google_remarketing_only = false;
/* ]]> */
</script>
<script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js">
</script>
<noscript>
<div style="display:inline;">
<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/1036218422/?label=7jGxCI2m9IUBELbgje4D&amp;guid=ON&amp;script=0"/>
</div>
</noscript>

<template>
  <div id="resultado1" class="page-container">

      <div id="resultado-left-box" class="pull-left" :style="{ 'backgroundImage': 'url(\'' + bg_image + '\')' }"></div>
      <div class="box pull-left">
          <div class="wrap-585">
            <h4>A pontuação indica que você tem:</h4>
            <h1 class="text-green m-t-10">Boa audição</h1>
            <h6 class="m-t-10">Gostariamos de reforçar que essa triagem não substitui um exame auditivo, por exemplo audiometria, se você sente dificuldade para ouvir em algumas situações, recomendamos que agende uma consulta com um médico otorrinolaringologista.<br><br>Se tiver qualquer dúvida, entre em contato conosco.</h6>

            <!--
            <h5 class="m-t-30">Enviamos um cupom de desconto para o e-mail cadastrado, agende uma consulta em um ponto de atendimento Phonak por meio do 0800 701 8105.</h5>
            <h6>No caso de não encontrar o cupom em seu e-mail, verifique a caixa de SPAM.</h6>
            -->
          </div>

          <hr class="bg-green m-t-30" />

          <div class="wrap-585">
            <h5>Você ganhou um <span class="text-green">cupom de desconto</span> para <br>utilizar na compra de aparelhos auditivos <span class="text-green">Phonak</span>.</h5>
            <img src="assets/cupom.png" />
            <h5>Apresente em uma de nossas revendas <br>oficiais e ganhe o desconto na hora. <br>Foto do cupom no celular também vale. <span class="text-green"> Aproveite!</span></h5>
            <h6 class="m-t-20">Encontre a revenda mais próxima de você.<br> Entre em contato no 0800 701 8105 ou acesse o nosso site.</h6>
            <b-button pill class="m-t-30 btn-success w-76 boldit start_again" v-on:click="start_again">Realizar o teste novamente</b-button>
            <h6 class="m-t-20"><small>* Cupons não cumulativos. Promoção válida do dia 01/12/2019 à 15/01/2020. Consulte médico otorrinolaringologista.</small></h6>
          </div>
      </div>
  </div>
</template>

<script>
gtag('event', 'conversion', {'send_to': 'AW-1036218422/7jGxCI2m9IUBELbgje4D'});

import { bus } from '../main';

export default {
  name: "Resultado1",
  data() {
      return {

        show: true,
        bg_image: require('../../assets/resultado1.png')
      }
    },
    props:['count'],
    methods: {
      start_again() {
        this.$router.push('page1')
      }
    }
}
</script>

<style scoped>

#resultado1 {
  max-width: 100% !important;
  padding-top: 0px;
}
#resultado1 .box {
    /*height: 920px;
    max-height: 920px;
    width: calc(100% - calc(100% - 585px)) !important;*/
    padding-top: 30px;
    border:0px solid;
}
#resultado1 .box h1 {
  font-size: 3.5em !important;
  padding-bottom: 5px;
}
#resultado-left-box {
  width: calc(100% - 585px);
  height: 780px;
  background-repeat: no-repeat;
  border:0px solid;
}
#resultado1 .wrap-585 {
    width: 585px;
    padding-left: 35px !important;
    padding-right: 35px !important;

}

#resultado1 h6 {
  font-size: 1em;
}


#resultado1 h5 {
  font-size: 1.1em;
}

#resultado1 small {
  font-size: 0.6em;
}


@media only screen
  and (min-width: 1600px) {
      /**
      * RESULTADOS
      */
      #resultado1 .box {
          /*height: 920px;
          max-height: 920px;*/
          width: calc(100% - 960px) !important;
          padding-top: 30px;


          border:0px solid;
      }
}

@media only screen
  and (max-width: 599px) {
  .page-container, #resultado-left-box {
    background-size: 100% !important;
  }
  #resultado-left-box {
    width: 100%;
    height: 300px;
  }
  #resultado1 .box {
    width: 100% !important;
    background-color: white;
    margin-top: 0px;
    text-align: center;
    padding: 10px 20px !important;
  }
  #resultado1 .wrap-585 {
    width:100%;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  h1 {
    font-size: 2rem;
    text-align: center;
  }

  .start_again {
    width:100% !important;
    margin-bottom: 15px;
  }

  .m-l-60 {
    margin-left: 20px;
  }
}


</style>
